import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Loading } from "@jd/focus-desktop-comps";
import { Button, Progress, Drawer, message } from "antd";
import { debounce, throttle } from "lodash";
import { BrowserViewContext, BrowserViewItem } from "./utils";
import { PlusOutlined, MinusOutlined, CaretRightOutlined } from "@/utils/antdIcon";
import IconFont, {
  IconArrowLeft,
  IconArrowRight,
  IconMore,
  IconRefresh,
  IconWindowPop
} from "@/components/icon";
import sentryManual from "@/utils/sentryManual";
import styles from "@/components/styles";
import ErrorPage, { ErrorType, ErrorInfo } from "./ErrorPage";
import "./webview.less";
import { changeEgovUrl } from "@/utils/tools";
import { checkJoyspaceUrlAll } from "@/components/Joyspace/util";
// const preloadJS = `file://${remote.app.getAppPath()}/browser/webview/AppPreload.js`;
// console.log('AppPreload =>', preloadJS);

import logger from "@/utils/logger";
import { RegistryConfigData } from "@/types/LocalConfig";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { getAuthorizationCode } from "@/api/user";
import { connect } from "dvajs";
import Axios from "axios";
import { FocusSDK, isInnerApp, isLinuxOs } from "@/utils";
import { joinMeeting, joinLive } from "@/baseComponents/Meeting/utils";
import { createMeetingWithUsers } from "@/baseComponents/Meeting/openUtils";
import { useHistory, useLocation } from "react-router-dom";
import { sleep } from "@/utils/chat/message";
import { getWatermark } from "@/utils/ui";

const log = logger.getLogger("BrowserView/Webview");
import { openUserSelectionModal } from "@/utils/modals";
import { UserModel } from "@/models/user";
import bus from "@/utils/bus";
import { addEventListener, removeEventListener } from "./EventManager";
import { AVSDK } from "@/baseComponents/Meeting/common";
import { createMeeting } from "@/api/meeting";
import dayjs from "dayjs";
import { MeetingPlatform } from "@/types/common";
import { batchSendMessage } from "@/components/BrowserView/msgCardHelper";
import { PerformanceContext, appTrailApply } from "@/components/ThirdApp/utils";
import { analysisLog } from "@/utils/logAnalytics";
import ChatMain from "@/baseComponents/Chat/view/Main";
import ImService from "@/server/ImService";

import SearchBar from "./SearchBar";

let curCid = "";

// const preloadJS = `file://${remote.app.getAppPath()}/browser/webview/AppPreload.js`;

const DEFAULT_HOST_LIST = [
  "jzb.beijing.gov.cn",
  "jzb.beijing.egov.cn",
  "jdcloud.com",
  "jd_third.com",
  "jd.com",
  "jzb-test.jdcloud.com"
];

function filterUserInfo(data: RegistryConfigData): any {
  if (!data.auth) {
    return null;
  }
  const { realName, nickName, teamUserInfo, headImg, account, userId, ddAppId } = data.auth;
  return {
    realName,
    nickName,
    teamUserInfo,
    headImg,
    account,
    selectedTeamId: data,
    userId,
    ddAppId
  };
}

function WebView({
  item,
  visible,
  src,
  withToolbar,
  thirdAppMap,
  updatehirdAppList,
  resetPartition,
  setShareContentMap
}: // onGetSrc
{
  src?: string;
  // onGetSrc?: () => Promise<string>;
  item: BrowserViewItem;
  visible?: boolean;
  withToolbar?: boolean;
  thirdAppMap?: any;
  updatehirdAppList: Function;
  resetPartition: boolean;
  setShareContentMap: Function;
}) {
  const {
    onNewWindowOpen,
    onWindowClose,
    onPageMetaDataChanged,
    onPageLinkChanged,
    registryConfigData,
    notifier,
    configData = { allowedHosts: [], partition: "builtin-third-apps" },
    openWebViewModal,
    closeWebViewModal,
    setShareable,
    openCommonModal,
    openGroupChat,
    openSingleChat,
    openUserCard,
    viewImages,
    openExternal,
    webviewModalVisible,
    selectedId,
    ChatviewVisible,
    onChangeChatviewVisible,
    toolMenuVisible,
    setToolMenuVisible,
    openThirdApp
  } = React.useContext(BrowserViewContext);

  const loadCurrentFileTime = new Date().getTime();

  const history = useHistory();
  const { appClickTime } = React.useContext(PerformanceContext);
  const {
    authInfo,
    focusSDK,
    appRuntimeEnv,
    service,
    currentEmployee,
    waterMarkText,
    hiddenWaterMarkText
  } = React.useContext<GlobalContextConfig>(GlobalContext);
  // const [link, setLink] = useState(src);
  const [percent, setPercent] = useState(0);
  const [ready, setReady] = useState(false);
  const [progressShow, setProgressShow] = useState(true);
  const webview = React.useRef<HTMLWebViewElement | null>(null);
  const sidRef: any = React.useRef(0);
  const percentRef = React.useRef(0);
  const [loadFailInfo, setLoadFailInfo] = useState<ErrorInfo | null>(null);
  const currUrl = React.useRef("");
  percentRef.current = percent;
  const [webViewModalCid, setWebViewModalCid] = useState("");
  let comp = <Loading style={{ height: "100%" }} />;
  const [preWebviewModalVisible, setPreWebviewModalVisible] = useState(webviewModalVisible);
  const [isJoyspaceUrlState, setIsJoyspaceUrlState] = useState(false);
  const isDomReady = React.useRef<boolean>(false);
  const performanceRef = React.useRef("");
  const [scale, setScale] = useState(100);
  const [gobackDisabled, setGobackDisabled] = useState(true);
  const [goForwardDisabled, setGoForwardDisabled] = useState(true);
  const fullRef = React.useRef(null);
  const [showFullScreenMessage, setShowFullScreenMessage] = useState(false);
  const didLoadingStartTime = React.useRef(0);
  const didStopLoadingTimer = React.useRef<any>(null);
  const webviewRef = webview.current as any;
  const formUrlList = React.useRef([] as any[]);
  const [searchBarVisible, setSearchBarVisible] = useState(false);
  const location = useLocation();

  const wvfsWatermark = useMemo(() => {
    return getWatermark({
      top: 80,
      mountElId: `web-view-${item.id}`
    });
  }, [item]);
  const wvfsHiddenWatermark = useMemo(() => {
    return getWatermark({
      color: "#000000",
      opacity: 0.005,
      fontSize: 12,
      mountElId: `web-view-${item.id}`
    });
  }, [item]);
  useEffect(() => {
    const wv = webview.current as any;
    if (!webviewModalVisible && preWebviewModalVisible && webViewModalCid) {
      wv.send("clientMessage", {
        cid: webViewModalCid,
        data: null
      });
      setPreWebviewModalVisible(false);
    }
    if (!preWebviewModalVisible && webviewModalVisible) {
      setPreWebviewModalVisible(true);
    }
  }, [webviewModalVisible, webViewModalCid, preWebviewModalVisible]);

  useEffect(() => {
    try {
      const wv = webview?.current as any;
      if (wv && item?.id === selectedId) {
        const currentZoomFactor = wv.zoomFactor;
        setScale(currentZoomFactor * 100);
      }
    } catch (e) {}
  }, [selectedId, item]);

  const onFullScreenChange = (e: any) => {
    if (!document.fullscreenElement) {
      console.log("exitFullScreen");
      wvfsWatermark.removeWatermark();
      wvfsHiddenWatermark.removeWatermark();
    } else {
      console.log("fschange~~~~fullscreen", e);
      wvfsWatermark.setWaterMark(waterMarkText);
      wvfsHiddenWatermark.setWaterMark(hiddenWaterMarkText);
    }
  };
  useEffect(() => {
    // 监听退出全屏事件 --- chrome 用 esc 退出全屏并不会触发 keyup 事件
    document.addEventListener(
      "webkitfullscreenchange",
      onFullScreenChange
    ); /* Chrome, Safari and Opera */
    document.addEventListener("mozfullscreenchange", onFullScreenChange); /* Firefox */
    document.addEventListener("fullscreenchange", onFullScreenChange); /* Standard syntax */
    document.addEventListener("msfullscreenchange", onFullScreenChange); /* IE / Edge */
    return () => {
      // 销毁时清除监听
      document.removeEventListener("webkitfullscreenchange", onFullScreenChange);
      document.removeEventListener("mozfullscreenchange", onFullScreenChange);
      document.removeEventListener("fullscreenchange", onFullScreenChange);
      document.removeEventListener("MSFullscreenChange", onFullScreenChange);
    };
  }, []);

  const sendIpcMessage = () => {
    const wv = webview.current as any;
    wv.send("clientMessage", {
      cid: curCid,
      data: JSON.stringify({ type: "updateGroupRosters" })
    });
  };

  const clstag = useCallback(() => {
    console.log("current_pathname", location.pathname);
    const pathname = location.pathname;
    // if (pathname === '/address_list') {
    //     analysisLog('xtbg_add_home_1637657110163', '40');
    // }
    if (pathname?.startsWith("/messages")) {
      // analysisLog('Xtbg_Msg_Home', 'Search');
      analysisLog("xtbg_home_search_1641454991771", "9");
      return;
    }
    switch (pathname) {
      case "/address_list":
        analysisLog("xtbg_home_search_1641454991771", "38");
        break;
      case "/projects":
        analysisLog("xtbg_home_search_1641454991771", "34");
        break;
      case "/calendar":
        analysisLog("xtbg_home_search_1641454991771", "35");
        break;
      case "/joyspace/home/recent":
        analysisLog("xtbg_home_search_1641454991771", "36");
        break;
      case "/third_apps":
        analysisLog("xtbg_home_search_1641454991771", "37");
        break;
    }
  }, [location?.pathname]);
  useEffect(() => {
    const pathname = location?.pathname || "";
    const localUrl = new URL(window.location?.href) || "";
    const pageName = localUrl.searchParams.get("page");
    console.log("pageNametest", pageName, pathname);
    if (pathname === "/homePage" || pathname === "/third_apps" || pageName === "builtin-browser") {
      bus.on(`${item.id}refreshCb`, refreshCb);
      bus.on(`${item.id}goForwardCb`, goForwardCb);
      bus.on(`${item.id}goBackCb`, goBackCb);
      bus.on(`${item.id}handleZoomOut`, handleZoomOut);
      bus.on(`${item.id}handleZoomIn`, handleZoomIn);
      bus.on(`${item.id}handleZoomReset`, handleReturn100);
      bus.on(`${item.id}openThirdappNewWindow`, openThirdappNewWindow);
      bus.on(`${item.id}openDevtools`, handleOpenDevtools);
      bus.on(`${item.id}ClearCache`, handleClearCache);
      bus.on(`${item.id}fullScreen`, fullScreen);
    } else {
      bus.off(`${item.id}refreshCb`, refreshCb);
      bus.off(`${item.id}goForwardCb`, goForwardCb);
      bus.off(`${item.id}goBackCb`, goBackCb);
      bus.off(`${item.id}handleZoomOut`, handleZoomOut);
      bus.off(`${item.id}handleZoomIn`, handleZoomIn);
      bus.off(`${item.id}ClearCache`, handleClearCache);
      bus.off(`${item.id}handleZoomReset`, handleReturn100);
      bus.off(`${item.id}openThirdappNewWindow`, openThirdappNewWindow);
      bus.off(`${item.id}openDevtools`, handleOpenDevtools);
      bus.off(`${item.id}fullScreen`, fullScreen);
    }
    return () => {
      bus.off(`${item.id}refreshCb`, refreshCb);
      bus.off(`${item.id}goForwardCb`, goForwardCb);
      bus.off(`${item.id}goBackCb`, goBackCb);
      bus.off(`${item.id}handleZoomOut`, handleZoomOut);
      bus.off(`${item.id}handleZoomIn`, handleZoomIn);
      bus.off(`${item.id}ClearCache`, handleClearCache);
      bus.off(`${item.id}handleZoomReset`, handleReturn100);
      bus.off(`${item.id}openThirdappNewWindow`, openThirdappNewWindow);
      bus.off(`${item.id}openDevtools`, handleOpenDevtools);
      bus.off(`${item.id}fullScreen`, fullScreen);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready, webviewRef, location]);

  useEffect(() => {
    bus.on("updateGroupRosters", sendIpcMessage);
    return () => {
      bus.off("updateGroupRosters", sendIpcMessage);
    };
  }, []);

  const fetchThirdApps = useCallback(async () => {
    if (!authInfo || (!isLinuxOs() && !navigator.onLine)) {
      return;
    }
    const group = await service.appStoreService
      .getGroupApplications({
        userId: authInfo?.userId,
        teamId: appRuntimeEnv.selectedTeamId
      })
      .catch((e) => {
        console.log("fetchThirdApps--error: ", e);
      });
    if (!group) {
      return;
    }
    const { groupApplications } = group;

    if (groupApplications) {
      const thirdAppList = groupApplications.reduce((a: any, b: any) => {
        return a.concat(b.applications);
      }, []);
      if (thirdAppList?.length) {
        await updatehirdAppList({ thirdAppList });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appRuntimeEnv.selectedTeamId, authInfo?.userId, service.appStoreService]);

  useEffect(() => {
    fetchThirdApps();
  }, [fetchThirdApps]);

  const increasePercent = React.useCallback((p: number) => {
    if (percentRef.current >= 100) {
      return;
    }
    if (p >= 100) {
      setPercent(100);
      if (sidRef.current) {
        clearTimeout(sidRef.current);
      }
      setTimeout(() => {
        setProgressShow(false);
      }, 500);
      return;
    }
    const n = p + 20;
    setPercent(n >= 90 ? 90 : n);
    sidRef.current = setTimeout(() => {
      increasePercent(n);
    }, 500);
  }, []);

  const isTrustHost = async (url: string, hosts: string[], thirdAppMap: any) => {
    // performance.mark("isTrustHostStart");
    const hostName = new URL(url).hostname;
    let HOST_LIST = DEFAULT_HOST_LIST;
    try {
      const configHost = FocusSDK.isPrivateNet()
        ? "https://jzb.beijing.egov.cn/oss/focus-desktop"
        : "https://focus-desktop.s3.cn-north-1.jdcloud-oss.com";
      const { data, status } = await Axios.get(
        `${configHost}/config/${appRuntimeEnv.envConfig.key}/jssdk-config.json?d=${Date.now()}`
      );
      if (status === 200) {
        const { whiteList } = data;
        if (Array.isArray(whiteList)) {
          HOST_LIST = Array.from(new Set(DEFAULT_HOST_LIST.concat(whiteList)));
        }
      }
    } catch (error) {
      console.error(error);
    }
    log.debug("HOST_LIST111", HOST_LIST, hostName);
    if (HOST_LIST.length > 0) {
      const res = [...HOST_LIST].filter((i: string) => hostName.indexOf(i) > -1);
      log.debug("HOST_LIST222", HOST_LIST, res);
      if (res.length > 0) {
        return true;
      }
    }
    if (hosts.length !== 0) {
      const res = [...hosts, ...HOST_LIST].filter((i: string) => hostName.indexOf(i) > -1);
      // performance.mark("isTrustHostEnd");
      // let isTrustHostMeasure = performance.measure(
      //   "isTrustHost",
      //   "isTrustHostStart",
      //   "isTrustHostEnd"
      // );
      // // @ts-ignore
      // log.debug("isTrustHost", isTrustHostMeasure.duration);
      return res.length > 0;
    } else {
      const apps = Object.keys(thirdAppMap || {});
      for (let k of apps) {
        const item = thirdAppMap[k];
        if (item) {
          const hosts = item.trustedDomains ? item.trustedDomains.split(";") : [];
          const res = [...hosts, ...HOST_LIST].filter((i: string) => hostName.indexOf(i) > -1);
          if (res.length > 0) {
            return true;
          }
        }
      }
      // performance.mark("isTrustHostEnd");
      // let isTrustHostMeasure = performance.measure(
      //   "fetchThirdApps",
      //   "fetchThirdAppsStart",
      //   "fetchThirdAppsEnd"
      // );
      // // @ts-ignore
      // log.debug("isTrustHost", isTrustHostMeasure.duration);
      return false;
    }
  };
  const failLoadCb = React.useCallback((err: any) => {
    const now = new Date().getTime();
    let isBeta = focusSDK.isBeta();
    const sta_ts = appClickTime || loadCurrentFileTime;
    const performanceWebviewLoadTime: any = {
      sta_ts,
      end_ts: now,
      debug: !isBeta,
      clp: item.appKey,
      pref_ts: {
        up1_et: didLoadingStartTime.current - sta_ts,
        up2_et: now - didLoadingStartTime.current
      },
      ext_param: {
        status: 1,
        url: currUrl.current
      }
    };
    analysisLog("xtbg_pc_perf", "webview_loadtime", JSON.stringify(performanceWebviewLoadTime));
    log.error(`webview Third app(${item.name}:${item.id}) load err: `, err);
    sentryManual.captureMessage(
      `webview Third app ${item.name}加载失败， 原因：${JSON.stringify(err)}`,
      "webview-third-app-fail"
    );
    if (err?.errorCode === -3) {
      return;
    }
    try {
      FocusSDK.printLog(
        `webview Third app(${JSON.stringify(item)}) load err: ${JSON.stringify(err)}`
      );
    } catch (e) {
      console.log(e);
    }
    setLoadFailInfo({
      type: ErrorType.TIMEOUT,
      isMainFrame: err?.isMainFrame === false ? false : true
    });
    // increasePercent(100);
  }, []); // eslint-disable-line

  const onResponseCb = React.useCallback(
    (rep: any) => {
      isDomReady.current = false;
      log.debug("webview onResponseCb", rep);
      const url = rep.url;
      currUrl.current = url;
      if (!rep) {
        setLoadFailInfo({
          type: ErrorType.TIMEOUT,
          isMainFrame: true
        });
        sentryManual.captureMessage(
          `webview Third app ${item.name}加载失败， 原因：timeout`,
          "webview-third-app-fail-timeout"
        );
        return;
      }
      if (rep.httpResponseCode === 404) {
        setLoadFailInfo({
          type: ErrorType.NOTFOUND,
          code: rep.httpResponseCode,
          isMainFrame: true
        });
        sentryManual.captureMessage(
          `webview Third app ${item.name}加载失败， 原因：404`,
          "webview-third-app-fail-404"
        );
        return;
      } else if (rep.httpResponseCode === 504 || rep.httpResponseCode === 408) {
        setLoadFailInfo({
          type: ErrorType.TIMEOUT,
          code: rep.httpResponseCode,
          isMainFrame: true
        });
        sentryManual.captureMessage(
          `webview Third app ${item.name}加载失败， 原因：timeout`,
          "webview-third-app-fail-timeout"
        );
        return;
      } else if (rep.httpResponseCode === 401 || rep.httpResponseCode === 403) {
        setLoadFailInfo({
          type: ErrorType.FORBIDEN,
          code: rep.httpResponseCode,
          isMainFrame: true
        });
        sentryManual.captureMessage(
          `webview Third app ${item.name}加载失败， 原因：forbiden`,
          "webview-third-app-fail-forbiden"
        );
        return;
      } else if (rep.httpResponseCode === 412 || rep.httpResponseCode === 521) {
        return;
      } else {
        const num = parseInt(`${(parseInt(rep.httpResponseCode, 10) % 1000) / 100}`, 10);
        if (num === 4 || num === 5) {
          setLoadFailInfo({
            type: ErrorType.SEVERERROR,
            code: rep.httpResponseCode,
            isMainFrame: true
          });
          sentryManual.captureMessage(
            `webview Third app ${item.name} 加载失败， 原因：severError`,
            "webview-third-app-fail-severError"
          );
          return;
        }
      }
      setLoadFailInfo(null);
    },
    [item]
  );

  const readyCb = React.useCallback(
    async (rep: any) => {
      if (isDomReady.current) {
        return;
      }
      const trustedDomains = item.trustedDomains ? item.trustedDomains.split(";") : [];
      if (item.isFormSubmit) {
        const extraData: any = item.extraData;
        const url: any = extraData.url;

        if (!formUrlList.current.includes(url)) {
          const referrer = extraData.referrer;
          const extraHeadersArray = [
            `Content-Type: ${extraData.postBody.contentType}; charset=UTF-8`
          ];
          // @ts-ignore
          webview?.current?.loadURL(url, {
            httpReferrer: referrer,
            extraHeaders: extraHeadersArray.join("\n"),
            postData: extraData.postBody.data
          });
          formUrlList.current.push(url);
        }
      }
      // 检测域名
      // try {
      //   const isTrust = await isTrustHost(currUrl.current, trustedDomains, thirdAppMap);
      //   if (isTrust || item.isThirdApp === false) {
      //     (webview.current as any).executeJavaScript(
      //       "window.FocusSDK && window.FocusSDK.install &&  window.FocusSDK.install()"
      //     );
      //   } else {
      //     (webview.current as any).executeJavaScript("window.FocusSDK={}");
      //   }
      //   console.log(`Third app(${item.name}:${item.id}) ready.`, rep, isTrust);
      // } catch (e) {
      //   console.error("readyCb--err", e);
      // }
      const wv = webview.current as any;
      const currentZoomFactor = wv?.zoomFactor;
      wv?.setZoomFactor(currentZoomFactor);
      setScale(currentZoomFactor * 100);
      setReady(true);
      increasePercent(100);
      setTimeout(() => {
        if (webview.current) {
          webview.current.blur();
          webview.current.focus();
        }
      }, 0);
      isDomReady.current = true;
    },
    [increasePercent, currUrl, thirdAppMap] //eslint-disable-line
  );

  // const foundInPgCb = React.useCallback((e: any) => {
  //   // eslint-disable-next-line no-console
  //   console.log("xtl: we found it!!!", e);
  // }, []); // eslint-disable-line

  const refreshCb = React.useCallback(() => {
    if (webview.current) {
      setReady(false);
      // @ts-ignore
      const wvsrc = webview.current.src;
      const isJoyspaceUrl = checkJoyspaceUrlAll(wvsrc).is;
      setIsJoyspaceUrlState(isJoyspaceUrl);
      if (item.homeUrl?.includes("/jdmeet")) {
        ImService.getInstance().closeLive();
      }
      console.log("wvsrc", wvsrc, src);
      // 文档和链接不需要拼接focus-open-code，直接刷新
      if (
        isJoyspaceUrl ||
        !item?.isThirdApp ||
        src?.includes("passport/api/desktop/app/redirect/")
      ) {
        // @ts-ignore
        webview.current.reload();
      } else {
        const url = new URL(wvsrc);
        url.searchParams.delete("focus-open-code");
        // console.log('this is url', url);
        const hasUrlSearh = src && src?.indexOf("?") > 0;
        // @ts-ignore
        webview.current.loadURL(
          // @ts-ignore
          `${src}${hasUrlSearh ? "&" : "?"}redirectUrl=${encodeURIComponent(url)}`
        );
      }
      // console.log('this is src', src);
      setScale((webview.current as any).zoomFactor * 100);
      if (webview.current) {
        // webview.current.blur();
        webview.current.focus();
      }
    } else {
      setLoadFailInfo(null);
    }
  }, [item, src]);
  const reloadIgnoringCache = React.useCallback(() => {
    if (webview.current) {
      (webview.current as any).reloadIgnoringCache();
    }
  }, []);
  const handleZoomIn = React.useCallback(() => {
    const wv = webview.current as any;
    const currentZoomFactor = wv.zoomFactor;
    if (currentZoomFactor * 100 < 500) {
      const newScale = currentZoomFactor * 100 + 10;
      setScale(newScale);

      if (webview.current) {
        wv.setZoomFactor(newScale / 100);
      }
    }
  }, [webview, setScale]);
  const handleZoomOut = React.useCallback(() => {
    const wv = webview.current as any;
    const currentZoomFactor = wv.zoomFactor;
    if (currentZoomFactor * 100 > 25) {
      const newScale = currentZoomFactor * 100 - 10;
      setScale(newScale);
      if (webview.current) {
        wv.setZoomFactor(newScale / 100);
      }
    }
  }, [webview, setScale]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleZoomInALittle = React.useCallback(
    throttle(() => {
      const wv = webview.current as any;
      const currentZoomFactor = wv.zoomFactor;
      if (currentZoomFactor * 100 < 500) {
        const newScale = currentZoomFactor * 100 + 10;
        setScale(newScale);

        if (webview.current) {
          wv.setZoomFactor(newScale / 100);
        }
      }
    }, 50),
    [webview, setScale]
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleZoomOutALittle = React.useCallback(
    throttle(() => {
      const wv = webview.current as any;
      const currentZoomFactor = wv.zoomFactor;
      if (currentZoomFactor * 100 > 25) {
        const newScale = currentZoomFactor * 100 - 10;
        setScale(newScale);
        if (webview.current) {
          wv.setZoomFactor(newScale / 100);
        }
      }
    }, 50),
    [webview, setScale]
  );
  const handleReturn100 = React.useCallback(() => {
    const wv = webview.current as any;
    setScale(100);
    if (webview.current) {
      wv.setZoomFactor(1);
    }
  }, [webview, setScale]);
  const exitFullScreen = React.useCallback(() => {
    const full = fullRef.current as any;
    if (full.exitFullscreen) {
      full.exitFullscreen();
    } else if (full.mozCancelFullScreen) {
      full.mozCancelFullScreen();
    } else if (full.webkitExitFullscreen) {
      full.webkitExitFullscreen();
    } else if (full.cancelFullScreen) {
      full.cancelFullScreen();
    }
    wvfsWatermark.removeWatermark();
    wvfsHiddenWatermark.removeWatermark();
  }, []);

  const fullScreen = React.useCallback(() => {
    console.log("fffffful");
    const full = fullRef.current as any;
    setShowFullScreenMessage(true);
    // 设置5秒后自动消失
    setTimeout(() => {
      setShowFullScreenMessage(false);
    }, 5000);
    if (full.requestFullScreen) {
      full.requestFullScreen();
    } else if (full.webkitRequestFullScreen) {
      full.webkitRequestFullScreen();
    } else if (full.mozRequestFullScreen) {
      full.mozRequestFullScreen();
    } else if (full.msRequestFullscreen) {
      full.msRequestFullscreen();
    }
  }, []);
  const openThirdappNewWindow = React.useCallback(() => {
    console.log("openThirdappNewWindow", item);
    FocusSDK.openThirdappNewWindow({ src: src || "", item });
    // closeWebViewModal(webview.current?.id.replace("thridapp-", ""));
    // onWindowClose(item.id);
  }, [item, src]);
  const goForwardCb = React.useCallback(() => {
    const ref = webview.current as any;
    if (ref.canGoForward()) {
      ref.goForward();
    }
  }, []);
  const handleOpenDevtools = React.useCallback(() => {
    const ref = webview.current as any;
    ref?.openDevTools();
  }, []);
  const goBackCb = React.useCallback(() => {
    const ref = webview.current as any;
    if (ref.canGoBack()) {
      ref.goBack();
    }
  }, []);
  const handleClearCache = React.useCallback(() => {
    const wv = webview.current as any;
    const webContentsId = wv.getWebContentsId();
    focusSDK.clearCache({ webContentsId, selectedId });
  }, [focusSDK]);
  const newWindowCb = React.useCallback(
    (e: any) => {
      // if (checkJoyspaceUrlAll(e.url).is) {
      //     window.open(e.url);
      //     return;
      // }
      const url = new URL(e.url);
      const { protocol, host } = url;
      // console.log('--->', { protocol, host });
      if (!host) {
        return;
      }
      // TODO 这里需要校验 host
      if (!configData.allowedHosts.find((a: string) => a === host)) {
        // remote.shell.openExternal(e.url);
        // return;
      }
      if (protocol === "http:" || protocol === "https:") {
        e.preventDefault();
        const classNameArr = e.currentTarget.className.split(" ");
        // eslint-disable-next-line array-callback-return
        let classItem = "";
        classNameArr.forEach((item: any) => {
          if (item.indexOf("thridapp-") >= 0) {
            classItem = item;
          }
        });
        const currentTarget = e.currentTarget;
        if (!currentTarget) return;
        let appKey: any =
          currentTarget?.getAttribute?.("hidden-appkey") ||
          currentTarget?.id?.replace("thridapp-", "");
        let version: string = classItem.replace("thridapp-", "");
        console.log("应用版本号", appKey, version);
        if (onNewWindowOpen) {
          onNewWindowOpen(e.url, appKey, version);
        }
      }
    },
    [configData.allowedHosts, onNewWindowOpen]
  );

  const onDidStartLoading = useCallback(() => {
    if (!didLoadingStartTime.current) {
      didLoadingStartTime.current = new Date().getTime();
    }
  }, []);
  const onDidStopLoading = useCallback((e) => {
    const now = new Date().getTime();
    let isBeta = focusSDK.isBeta();
    clearTimeout(didStopLoadingTimer.current);
    didStopLoadingTimer.current = setTimeout(() => {
      const sta_ts = appClickTime || loadCurrentFileTime;
      const performanceWebviewLoadTime: any = {
        sta_ts,
        end_ts: now,
        debug: !isBeta,
        clp: item.appKey,
        pref_ts: {
          up1_et: didLoadingStartTime.current - sta_ts,
          up2_et: now - didLoadingStartTime.current
        },
        ext_param: {
          status: 2,
          url: currUrl.current
        }
      };
      analysisLog("xtbg_pc_perf", "webview_loadtime", JSON.stringify(performanceWebviewLoadTime));
    }, 60000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const bindEventsCb = React.useCallback(() => {
    if (!webview.current || !src) return;

    webview.current.removeEventListener("did-fail-load", failLoadCb);
    webview.current.addEventListener("did-fail-load", failLoadCb);

    webview.current.removeEventListener("did-navigate", onResponseCb);
    webview.current.addEventListener("did-navigate", onResponseCb);

    webview.current.removeEventListener("did-start-loading", onDidStartLoading);
    webview.current.addEventListener("did-start-loading", onDidStartLoading);

    webview.current.removeEventListener("did-stop-loading", onDidStopLoading);
    webview.current.addEventListener("did-stop-loading", onDidStopLoading);

    webview.current.removeEventListener("dom-ready", readyCb);
    webview.current.addEventListener("dom-ready", readyCb);
  }, [failLoadCb, onDidStartLoading, onDidStopLoading, onResponseCb, readyCb, src]);

  const preloadjs = useMemo(() => {
    if (!src) return "";
    const isJoyspaceUrl = checkJoyspaceUrlAll(src).is;
    setIsJoyspaceUrlState(isJoyspaceUrl);
    if (
      isJoyspaceUrl ||
      item?.isThirdApp === false ||
      isInnerApp(src) ||
      isInnerApp(item?.homeUrl)
    ) {
      return focusSDK.getInnerAppPreloadJSPath(item.version);
    }
    return focusSDK.getAppPreloadJSPath(item.version || "2.0.0");
  }, [focusSDK, item, src]);

  const handleDidNavigateCb = React.useCallback(
    (e: any) => {
      const url = e.url;
      if (url && url !== item?.link) {
        onPageLinkChanged &&
          onPageLinkChanged({
            id: item.id,
            link: url
          });
      }
    },
    [item.id, onPageLinkChanged]
  );

  const pageFaviconUpdatedCb = React.useCallback(
    ({ favicons, title }) => {
      if (!onPageMetaDataChanged) {
        return;
      }
      const src = (webview.current as any).src || "";
      console.log(src, 123);
      if (Array.isArray(favicons) && favicons.length) {
        onPageMetaDataChanged({
          id: item.id,
          favicon: favicons[0]
        });
      }

      if (title) {
        onPageMetaDataChanged({
          id: item.id,
          title
        });
      }
    },
    [item.id, onPageMetaDataChanged]
  );

  if (src) {
    console.log(src, "configData", configData);
    if (configData) {
      let partitionObj: any = {};
      // webview打开pdf必须去掉partition设置或者带persist:,参考https://github.com/electron/electron/issues/27121
      if (resetPartition) {
        partitionObj = {
          "hidden-appkey": item.appKey
        };
      } else {
        partitionObj = {
          partition: configData.partition,
          disablewebsecurity: true
        };
      }
      comp = loadFailInfo?.isMainFrame ? (
        <ErrorPage thirdAppInfo={item} errorInfo={loadFailInfo} />
      ) : (
        <div
          ref={fullRef}
          id={`web-view-${item.id}`}
          style={{ height: "100%", backgroundColor: "#fff" }}
        >
          {showFullScreenMessage && (
            <div
              style={{
                position: "fixed",
                top: "6%",
                left: "50%",
                transform: "translate(-50%)",
                fontSize: "20px",
                color: "#fff",
                background: "rgba(0, 0, 0, 0.3)",
                padding: "10px 20px",
                borderRadius: "10px"
              }}
            >
              按【ESC】即可退出全屏模式
            </div>
          )}
          <SearchBar
            webviewRef={webview}
            wvItem={item}
            ready={ready}
            visible={searchBarVisible}
            setVisible={setSearchBarVisible}
          />
          <webview
            ref={(ref) => {
              webview.current = ref;
              bindEventsCb();
            }}
            onrefresh={refreshCb}
            onFocus={() => {
              console.log("wvFOcus~~~");
              setToolMenuVisible?.(false);
            }}
            style={{ flex: 1, height: "100%" }}
            id={`thridapp-${item.id}`}
            className={`thridapp-${item.version} third_application_class`}
            src={changeEgovUrl(src)}
            // @ts-ignore
            allowpopups="true"
            preload={preloadjs}
            webpreferences="contextIsolation=no,sandbox=false"
            {...partitionObj}
          />
          <Drawer // 聊天抽屉
            title={null}
            width={543}
            className="thirdapp-chat-drawer"
            // mask={false}
            // closable={false}
            onClose={() => {
              onChangeChatviewVisible?.(false);
            }}
            visible={ChatviewVisible}
            getContainer={false}
          >
            {ChatviewVisible && (
              <ChatMain
                disBtns={{
                  voip: true,
                  meeting: true,
                  setup: true,
                  notice: true,
                  search: true
                }}
                customMemberFun={true}
                singleLine={true}
                memberUnit="个协作人"
              />
            )}
            {ChatviewVisible && (
              <Button
                className="unfold-btn"
                onClick={() => {
                  onChangeChatviewVisible?.(false);
                }}
              >
                <CaretRightOutlined className="unfold-icon" />
              </Button>
            )}
          </Drawer>
        </div>
      );
    }
  }

  const onContextMenu = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (focusSDK.isBeta()) {
      e.stopPropagation();
      e.preventDefault();
      // @ts-ignore
      webview?.current?.openDevTools();
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const wvRef: any = webview?.current;
    if (gobackDisabled !== (!ready || !wvRef || !wvRef?.canGoBack())) {
      setGobackDisabled(!gobackDisabled);
    }
    if (goForwardDisabled !== (!ready || !wvRef || !wvRef?.canGoForward())) {
      setGoForwardDisabled(!goForwardDisabled);
    }
  });
  useEffect(() => {
    bus.emit("goforward-btn-change", !goForwardDisabled);
  }, [goForwardDisabled]);
  useEffect(() => {
    bus.emit("goback-btn-change", !gobackDisabled);
  }, [gobackDisabled]);
  useEffect(() => {
    bus.emit("wv-scale-change", scale);
  }, [scale]);
  const toolbar = (
    <div
      className={["me-thirdapp-webview-toolbar", !withToolbar ? "no-toolbar" : ""].join(" ")}
      onContextMenu={onContextMenu}
    >
      {withToolbar && (
        <>
          <div className="me-thirdapp-webview-actions-l">
            <Button type="text" size="small" disabled={gobackDisabled} onClick={goBackCb}>
              {IconArrowLeft}
            </Button>
            <Button type="text" size="small" disabled={goForwardDisabled} onClick={goForwardCb}>
              {IconArrowRight}
            </Button>
            <Button
              type="text"
              size="small"
              onClick={refreshCb}
              onDoubleClick={reloadIgnoringCache}
            >
              <IconFont type="iconic_pc_refresh11" style={{ fontSize: "16px" }} />
            </Button>
            <span style={{ margin: "0 10px 0 20px", verticalAlign: "top" }}> | </span>
            <Button type="text" size="small" onClick={handleZoomOut}>
              <MinusOutlined />
            </Button>
            <span style={{ marginRight: "10px" }}>{scale.toFixed(0)}%</span>
            <Button type="text" size="small" onClick={handleZoomIn}>
              <PlusOutlined />
            </Button>
            <span style={{ marginRight: "20px", verticalAlign: "top" }}> | </span>
            {/* <Button type="text" size="small" onClick={fullScreen}>
              <FullscreenOutlined />
            </Button> */}
          </div>
          {item?.isNewWin ||
          item?.isThirdApp === false ||
          configData.partition !== "builtin-third-apps" ? (
            <div />
          ) : (
            <div className="me-thirdapp-webview-actions-r">
              <Button type="text" size="small" onClick={openThirdappNewWindow}>
                <IconFont type="iconic_pc_alone" style={{ fontSize: "16px" }} />
              </Button>
            </div>
          )}
        </>
      )}
      {progressShow && (
        <Progress
          type="line"
          strokeWidth={2}
          percent={percent}
          showInfo={false}
          trailColor="transparent"
          // strokeColor={styles.color.primary}
          className="webview-progress"
        />
      )}
    </div>
  );
  //
  // const onGlobalMessage = useCallback((_e: IpcRendererEvent, cid: string, data: any) => {
  //     log.debug('BrowserWindow Webview globalMessage', { cid, data });
  //     const wv = webview.current as any;
  //     if (!wv) {
  //         return;
  //     }
  //     wv.send('clientMessage', { cid, data });
  // }, []);

  // eslint-disable-next-line complexity
  const handleClientMessages = ({ cid, type, data }: any) => {
    // const webview = this.webviewRef.current as any;
    // const { config: contextConfig, service } = context as GlobalContextType;
    // console.log("handleClientMessages", { cid, type, data });
    if (!appRuntimeEnv) {
      log.error(
        "no appRuntimeEnv when handleClientMessages",
        JSON.stringify({ type, data }, null, "\t")
      );
      return;
    }
    // const { userDataForWeb } = authInfo;

    const wv = webview.current as any;
    switch (type) {
      case "performanceTiming":
        performanceRef.current = data;
        break;
      case "errInfo":
        sentryManual.captureMessage(
          `webview Third app ${item.name}加载代码报错， 报错详情：${data}`,
          "webview-third-app-fail-jserror"
        );
        break;
      case "loadResourcesErrInfo":
        sentryManual.captureMessage(
          `webview Third app ${item.name}有资源加载失败， 报错详情：${data}`,
          "webview-third-app-fail-load-resource"
        );
        break;
      case "checkNeedAuth":
        service.appStoreService
          .checkApplicationNeedAuth({
            userId: authInfo?.userId,
            teamId: appRuntimeEnv.selectedTeamId,
            mode: "sdk",
            appKey: data.appKey
          })
          .then((res) => {
            wv.send("clientMessage", {
              cid,
              data: res
            });
          })
          .catch((e) => {
            wv.send("clientMessage", {
              cid,
              data: {}
            });
          });
        break;
      case "submitApplicationAuth":
        service.appStoreService
          .submitApplicationAuth({
            userId: authInfo?.userId,
            teamId: appRuntimeEnv.selectedTeamId,
            mode: "sdk",
            appKey: data?.appKey,
            authorize: !!data.authorize
          })
          .then((res) => {
            wv.send("clientMessage", {
              cid,
              data: res
            });
          })
          .catch((e) => {
            wv.send("clientMessage", {
              cid,
              data: {}
            });
          });
        break;
      case "getUserInfo":
        wv.send("clientMessage", {
          cid,
          data: filterUserInfo(registryConfigData)
        });
        break;
      case "getThirdAppUserInfo":
      case "getAuthInfo":
        // log.debug('AppSdk ==>', 'getAuthInfo', JSON.stringify(userDataForWeb));
        wv.send("clientMessage", {
          cid,
          data: appRuntimeEnv.userDataForWeb
        });
        break;
      case "getAppRuntimeEnv":
        wv.send("clientMessage", {
          cid,
          data: appRuntimeEnv
        });
        break;
      case "openWebViewModal": {
        if (data) {
          setWebViewModalCid(cid);
          openWebViewModal(data);
        }
        break;
      }
      case "closeWebViewModal": {
        closeWebViewModal(webview.current?.id.replace("thridapp-", ""));
        // closeWebViewModal();
        // wv.send('clientMessage', {
        //     cid: webViewModalCid,
        //     data: null,
        // });
        break;
      }
      // 设置是否可以分享链接
      case "setShareable": {
        setShareable(webview.current?.id.replace("thridapp-", "") || "", data);
        setShareContentMap({ [item.id]: data });
        wv.send("clientMessage", {
          cid,
          data: null
        });
        break;
      }
      case "openCommonModal": {
        if (data) {
          openCommonModal(data);
        }
        // ipcRenderer.emit('openWebViewModal', null, 'about');
        break;
      }
      case "viewImages": {
        if (data) {
          viewImages(data);
        }
        // ipcRenderer.emit('openWebViewModal', null, 'about');
        break;
      }
      case "openExternal": {
        if (data) {
          openExternal(data);
        }
        break;
      }
      case "openDevTools": {
        // console.log('this is opendevtools');
        // @ts-ignore
        webview?.current?.openDevTools();
        break;
      }
      case "getAuthorizationCode": {
        getAuthorizationCode(data)
          .then((res) => {
            let result;
            const [success, err] = res;
            if (success) {
              result = {
                statusCode: 0,
                ...success
              };
            } else {
              result = {
                statusCode: 1,
                err
              };
            }
            wv.send("clientMessage", {
              cid,
              data: result
            });
          })
          .catch((err) => {
            console.log(err);
          });
        break;
      }
      case "openThirdapp": {
        openThirdApp?.(data.application);
        break;
      }
      case "openGroupChat": {
        if (data) {
          curCid = cid;
          openGroupChat(data);
        }
        break;
      }
      case "openSingleChat": {
        if (data) {
          openSingleChat(data);
        }
        break;
      }
      case "openUserSelectModel": {
        if (data) {
          const currentUser = (registryConfigData.auth as unknown) as UserModel;
          openUserSelectionModal(
            {
              ...data,
              currentUser: {
                pin: currentUser.userId,
                app: currentUser.ddAppId,
                teamId: currentUser.teamUserInfo.teamId
              }
            },
            (result, close) => {
              // eslint-disable-next-line no-debugger
              close?.();
              wv.send("clientMessage", {
                cid,
                data: result.data
              });
            },
            currentUser
          );
        }
        break;
      }
      case "addEventListener": {
        addEventListener({
          webviewId: item.id,
          eventName: data.eventName,
          cid
        });
        break;
      }
      case "removeEventListener": {
        removeEventListener({ webviewId: item.id, eventName: data.eventName });
        break;
      }
      case "createMeetingWithUsers": {
        const { appKey, topic, to = [] } = data;
        if (!appKey || !topic) {
          wv.send("clientMessage", {
            cid,
            data: {
              statusCode: -1,
              message: "参数缺失"
            }
          });
          return;
        }
        createMeetingWithUsers(
          {
            appKey,
            topic,
            to: to.slice(0, 100)
          },
          service
        )
          .then((res) => {
            wv.send("clientMessage", {
              cid,
              data: {
                statusCode: 1,
                message: to.length > 100 ? "最多同时邀请100人" : "",
                data: res
              }
            });
          })
          .catch((err) => {
            wv.send("clientMessage", {
              cid,
              data: {
                statusCode: -1,
                message: err?.message || err || "操作失败"
              }
            });
          });
        break;
      }
      case "createMeeting": {
        // 会议平台类型 0:joymeeting 1:xiaoyu 2:智能会议
        const { platformType, title, password } = data;
        if (!title) {
          wv.send("clientMessage", {
            cid,
            data: {
              statusCode: -1,
              message: "参数缺失"
            }
          });
          return;
        }
        let meetingPlatform = MeetingPlatform.CLOUD_UNION;
        if (platformType === 1) {
          meetingPlatform = MeetingPlatform.XYLINK;
        }
        if (platformType === 2) {
          meetingPlatform = MeetingPlatform.JBRTC;
        }
        createMeeting({
          platform: meetingPlatform,
          startTime: (dayjs().valueOf() + 5000).toString(),
          duration: 2,
          topic: title,
          password: password,
          participantIds: [
            {
              realName: currentEmployee.name,
              teamId: currentEmployee.teamId,
              userId: currentEmployee.userId,
              appId: currentEmployee.app,
              headImg: currentEmployee.avatar
            }
          ]
        }).then(([res, err]) => {
          wv.send("clientMessage", {
            cid,
            data: {
              data: res,
              statusCode: err ? -1 : 1
            }
          });
        });
        break;
      }
      case "joinMeeting": {
        const { platformType, meetingId, password } = data;
        if (!meetingId) {
          wv.send("clientMessage", {
            cid,
            data: {
              statusCode: -1,
              message: "参数缺失"
            }
          });
          return;
        }
        let avsdk = AVSDK.ZOOM;
        if (platformType === 1) {
          avsdk = AVSDK.XYLINK;
        }
        if (platformType === 2) {
          avsdk = AVSDK.JBRTC;
        }
        joinMeeting(avsdk, {
          meetingNumber: meetingId,
          meetingPassword: password
        })
          .then(() => {
            wv.send("clientMessage", {
              cid,
              data: {
                statusCode: 1
              }
            });
          })
          .catch((e) => {
            wv.send("clientMessage", {
              cid,
              data: {
                statusCode: -1,
                message: e?.message || e
              }
            });
          });

        break;
      }
      case "joinLive": {
        const { liveCode, livePassword, type = "jrtcLive" } = data;
        if (!liveCode) {
          wv.send("clientMessage", {
            cid,
            data: {
              statusCode: -1,
              message: "参数缺失"
            }
          });
          return;
        }
        joinLive(
          type,
          {
            liveCode,
            livePassword
          },
          history
        )
          .then(() => {
            wv.send("clientMessage", {
              cid,
              data: {
                statusCode: 0
              }
            });
          })
          .catch((e) => {
            console.error(e);
            wv.send("clientMessage", {
              cid,
              data: {
                statusCode: -1,
                message: e?.message || e
              }
            });
          });
        break;
      }
      case "openUserCard": {
        if (data) {
          openUserCard(data);
        }
        break;
      }
      case "batchSendMessage": {
        batchSendMessage({
          data,
          cid,
          service,
          sendToMessage: (arg: any) => {
            wv.send("clientMessage", arg);
          }
        });
        break;
      }
      case "appTrialDialog":
      case "appTrailApply": {
        // WebAppTrailApply({
        //   applicationId: data.applicationId,
        //   isExpired: data.isExpired,
        //   isUnApprove: data.isUnApprove,
        //   isSuccess: data.isSuccess,
        //   onOpenUrl: () => {
        //     notifier?.emit("clientMessage", {
        //       event: "openNewWindow",
        //       payload: {
        //         urls: [`${getAppEntry()}/app-apply.html?applicationId=${data.applicationId}`],
        //         name: item.name,
        //         version: item.version,
        //         isThirdApp: false
        //       }
        //     });
        //   }
        // });
        appTrailApply(
          data.applicationId,
          () => {},
          notifier,
          item,
          data.isInsideApp,
          (showTrialDialog: boolean) => {
            wv.send("clientMessage", {
              cid,
              data: {
                showTrialDialog
              }
            });
          }
        );
        break;
      }
      case "jssdklog": {
        analysisLog(
          "xtbg_jzb_jssdk_log",
          "jssdk_log",
          data.version,
          data.title || item.name,
          data.methodName,
          item?.appKey || "",
          data.err
        );
        break;
      }
      case "handleZoomIn":
        handleZoomIn();
        break;
      case "handleZoomOut":
        handleZoomOut();
        break;
      case "handleZoomInALittle":
        handleZoomInALittle();
        break;
      case "handleZoomOutALittle":
        handleZoomOutALittle();
        break;
      case "handleReturn100":
        handleReturn100();
        break;
      case "handleWvClose":
        onWindowClose?.(item.id);
        break;
      case "handlePageRefresh":
        refreshCb();
        break;
      case "handleGoBack":
        goBackCb();
        break;
      case "handleGoForward":
        goForwardCb();
        break;
      case "fullScreen":
        fullScreen();
        break;
      case "setShareContent":
        setShareContentMap({ [item.id]: data });
        break;
      default:
    }
  };

  const handleIPCMessage = (event: any) => {
    const { args, channel } = event;
    const [methodContent] = args || []; // 调用方法内容 方法名 方法参数
    switch (channel) {
      case "clientMessage":
        if (methodContent) {
          handleClientMessages(methodContent);
        }
        break;
      default:
        if (channel.startsWith("wv:")) {
          bus.emit(channel, methodContent);
        }
        break;
    }
  };
  const onGlobalWebviewMessage = (data: any) => {
    const wv = webview.current;
    if (!wv) {
      return () => {};
    }
    // if (process.env.REACT_APP_NODE_ENV !== "production") {
    //   FocusSDK.printLog("webviewMessage111", data);
    // }
    // @ts-ignore
    wv.send("webviewMessage", data);
  };
  useEffect(() => {
    const dispose = focusSDK.addIpcEventListener("global-webview-message", onGlobalWebviewMessage);
    // window.document.onkeydown = disableRefresh;

    // function disableRefresh(evt: any) {
    //   evt = evt ? evt : window.event;

    //   if (evt.keyCode) {
    //     console.log('ddddddddddd=>', evt.keyCode);
    //     message.info(evt.keyCode);
    //     if (evt.keyCode === 116) {
    //       evt.preventDefault(); // 阻止系统刷新。

    //       console.info(document.getElementById("iframepage")); // .contentWindow.location.reload(true);

    //       // let src = document.getElementById("iframepage").src;

    //       // document.getElementById("iframepage").src = src;
    //     }
    //   }
    // }
    return () => {
      dispose();
    };
  }, [focusSDK]);
  useEffect(() => {
    increasePercent(0);
    const wv = webview.current;
    if (!wv) {
      return () => {};
    }
    wv.addEventListener("ipc-message", handleIPCMessage);
    wv.addEventListener("page-favicon-updated", pageFaviconUpdatedCb);
    wv.addEventListener("page-title-updated", pageFaviconUpdatedCb);
    wv.addEventListener("new-window", newWindowCb);
    // 监听 URL 改变
    wv.addEventListener("did-navigate-in-page", handleDidNavigateCb);
    // ipcRenderer.on('gm.userSelectionAction', onGlobalMessage);

    return () => {
      wv.removeEventListener("ipc-message", handleIPCMessage);
      // 监听 URL 改变
      wv.removeEventListener("did-navigate-in-page", handleDidNavigateCb);
      wv.removeEventListener("page-favicon-updated", pageFaviconUpdatedCb);
      wv.removeEventListener("page-title-updated", pageFaviconUpdatedCb);
      wv.removeEventListener("new-window", newWindowCb);
      // ipcRenderer.off('gm.userSelectionAction', onGlobalMessage);
    };
  }, [increasePercent, newWindowCb, pageFaviconUpdatedCb]); //eslint-disable-line

  useEffect(() => {
    if (loadFailInfo) {
      // loadFailInfo.code = -103;
      // item.company = "jingdong";
      // item.phone = "13000000000;13000000001";
      // @ts-ignore
      webview?.current?.loadURL(
        `file://${FocusSDK.getAppErrorpagePath()}?errorcode=${JSON.stringify(
          loadFailInfo
        )}&thirdAppInfo=${JSON.stringify(item)}`
      );
    }
  }, [loadFailInfo, item]);
  useEffect(() => {
    if (visible && webview.current) {
      console.log("自动聚焦webview");
      // webview.current.blur();
      webview.current.focus();
    }
    if (visible) {
      bus.emit("goforward-btn-change", !goForwardDisabled);
      bus.emit("goback-btn-change", !gobackDisabled);
      bus.emit("wv-scale-change", scale);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  // console.log(444, webviewRef && webviewRef.canGoBack());

  return (
    <div
      key={item.id}
      style={{
        flex: 1,
        display: visible ? "flex" : "none",
        flexDirection: "column",
        height: "100%"
      }}
    >
      {/* {toolbar} */}
      {comp}
    </div>
  );
}

function mapStateToProps(props: { thirdapp: any }) {
  const { thirdapp } = props;
  return {
    thirdAppMap: thirdapp.thirdAppMap
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    updatehirdAppList: (data: { thirdAppList: any }) =>
      dispatch({
        type: "thirdapp/updatehirdAppList",
        payload: data
      }),
    setShareContentMap: (data: { shareContentMap: any }) =>
      dispatch({ type: "thirdapp/setShareContentMap", payload: data })
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WebView);
